import { appConfig } from "../config/appConfig.js";

/**
 * Screen Time suite: Parental Filter, DNS VPN, App Library, Lockbox Lab, Protection bar.
 * Keep code in the repo; flip this to true when you resume that work.
 */
export function isScreenTimeFeaturesEnabled() {
  const raw = String(
    (typeof process !== "undefined" &&
      (process.env?.EXPO_PUBLIC_SCREEN_TIME_ENABLED || process.env?.REACT_APP_SCREEN_TIME_ENABLED)) ||
      "",
  )
    .trim()
    .toLowerCase();
  if (raw === "true" || raw === "1" || raw === "yes") return true;
  if (raw === "false" || raw === "0" || raw === "no") return false;
  // Default OFF until Screen Time work resumes.
  return false;
}

/**
 * iOS Screen Time / Family Controls blocking UI (needs native AppBlockingModule + entitlements).
 * Default false: Parental Filter stays RN + DNS only until you flip this in app config.
 */
export function isIosFamilyControlsBlockingUiEnabled() {
  return appConfig.iosFamilyControlsBlockingUiEnabled === true;
}
